import { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./MainDashboard/Header";
import { Outlet } from "react-router-dom";
import AddTaskModal from "./MainDashboard/AddTaskModal";
import { useGlobalContext } from "../GlobalContext";
import LogoutWatcher from "./Utils/LogoutWatcher";

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);
  const { showOld, setShowOld, AdminId } = useGlobalContext();
  const [isAddTaskOpen, setIsAddTaskOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden">
          <LogoutWatcher type="admin" />

      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="flex-1 flex flex-col">
        <Header
          onAddTaskClick={() => setIsAddTaskOpen(true)}
          showOld={showOld}
          setShowOld={setShowOld}
        />

        {/* Important: render modal here so it overlays Outlet content */}
        <AddTaskModal
          isOpen={isAddTaskOpen}
          onClose={() => setIsAddTaskOpen(false)}
        />

        <div className="flex-1 overflow-y-auto p-2 bg-gray-50">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
